// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3fFP2","actionsCol":"EnrolledClinics_actionsCol__zTsyP"};